module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23237",
      "conversations-internal-schema": "static-1.11299",
      "head-dlb": "static-1.3878",
      "hs-test-utils": "static-1.6640",
      "hubspot-url-utils": "static-1.3027",
      "HubStyleTokens": "static-2.10144",
      "I18n": "static-7.1377",
      "jasmine-runner": "static-1.5051",
      "quartz": "static-1.5402",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.454",
      "enviro": "static-4.299",
      "hs-promise-rejection-tracking": "static-1.4156",
      "PortalIdParser": "static-2.277",
      "raven": "static-3.4615",
      "raven-hubspot": "static-1.4922",
      "bend-plugin-trellis-migration": "static-1.2308",
      "moment": "static-3.26",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4621",
      "transmute": "static-2.29",
      "HeadJS": "static-2.566",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.5809",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1751",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.120",
      "foundations-theming": "static-1.2958",
      "i18n-data": "static-1.196",
      "metrics-js": "static-1.8415",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4191",
      "jasmine": "static-4.2988",
      "quartz-core-utils": "static-1.2269",
      "csstype": "static-1.38",
      "copilot-toolkit": "static-1.5694",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http": "static-1.4807",
      "hub-http-janus": "static-1.638",
      "hub-http-shared-msw-handlers": "static-1.6882",
      "hubspotter-http": "static-1.3452",
      "hubspotter-http-shared-msw-handlers": "static-1.6880",
      "icons": "static-2.591",
      "mobile-manifest-mixins": "static-1.337",
      "platform-navigation-bootstrap": "static-1.11056",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15236",
      "react-router-dom": "static-5.26",
      "styled-components": "static-2.40",
      "ui-fonts": "static-1.331",
      "UIComponents": "static-3.7092",
      "bend-plugin-foundations-components": "static-1.2077",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3557",
      "foundations-theming-specialty": "static-1.675",
      "hs-story-utils": "static-1.8041",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.808",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-foundations-theming": "static-1.1441",
      "foundations-theming-base": "static-1.1943",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14923",
      "ts-schema": "static-1.3003",
      "sassPrefix": "static-1.130",
      "platform-infra-nav-components": "static-1.6560",
      "classnames": "static-2.10",
      "cssUtils": "static-1.464",
      "HubStyle": "static-2.10453",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23237",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11299",
      "head-dlb": "/head-dlb/static-1.3878",
      "hs-test-utils": "/hs-test-utils/static-1.6640",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3027",
      "HubStyleTokens": "/HubStyleTokens/static-2.10144",
      "I18n": "/I18n/static-7.1377",
      "jasmine-runner": "/jasmine-runner/static-1.5051",
      "quartz": "/quartz/static-1.5402",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.454",
      "enviro": "/enviro/static-4.299",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4156",
      "PortalIdParser": "/PortalIdParser/static-2.277",
      "raven": "/raven/static-3.4615",
      "raven-hubspot": "/raven-hubspot/static-1.4922",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2308",
      "moment": "/moment/static-3.26",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4621",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.566",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.5809",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1751",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.120",
      "foundations-theming": "/foundations-theming/static-1.2958",
      "i18n-data": "/i18n-data/static-1.196",
      "metrics-js": "/metrics-js/static-1.8415",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4191",
      "jasmine": "/jasmine/static-4.2988",
      "quartz-core-utils": "/quartz-core-utils/static-1.2269",
      "csstype": "/csstype/static-1.38",
      "copilot-toolkit": "/copilot-toolkit/static-1.5694",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-janus": "/hub-http-janus/static-1.638",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6882",
      "hubspotter-http": "/hubspotter-http/static-1.3452",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6880",
      "icons": "/icons/static-2.591",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.337",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11056",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15236",
      "react-router-dom": "/react-router-dom/static-5.26",
      "styled-components": "/styled-components/static-2.40",
      "ui-fonts": "/ui-fonts/static-1.331",
      "UIComponents": "/UIComponents/static-3.7092",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2077",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3557",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.675",
      "hs-story-utils": "/hs-story-utils/static-1.8041",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.808",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1441",
      "foundations-theming-base": "/foundations-theming-base/static-1.1943",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14923",
      "ts-schema": "/ts-schema/static-1.3003",
      "sassPrefix": "/sassPrefix/static-1.130",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6560",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.464",
      "HubStyle": "/HubStyle/static-2.10453",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};